const ParagraphBox = ({ paragraph, type }) => {
  return (
    <div style={{ padding: "10px" }}>
      {/* 상단에 '출제 지문' 제목 */}
      <div
        style={{
          fontSize: "18px",
          padding: "10px 0px",
          marginTop: "30px",
        }}
      >
        {paragraph.title || "출제 지문"}
      </div>

      {/* 박스: sentences 배열의 첫 번째 요소들 */}
      {type === "analysis" && (
        <div
          style={{
            border: "1px solid #EBEBEB",
            padding: "10px",
            marginBottom: "20px",
            borderRadius: "5px",
            fontSize: "16px",
            height: "490px",
            overflowY: "auto",
            lineHeight: "1.5",
          }}
        >
          {paragraph.data &&
            paragraph.data
              .filter((sectionData) => sectionData.type === "reading")[0]
              .data.map((sentence, index) => (
                <p key={index}>{sentence[0]}</p> // 0번째 element만 나열
              ))}
        </div>
      )}
      {type === "comprehensive" && (
        <div
          style={{
            border: "1px solid #EBEBEB",
            padding: "10px",
            marginBottom: "20px",
            borderRadius: "5px",
            fontSize: "16px",
            height: "490px",
            overflowY: "auto",
            lineHeight: "2",
          }}
        >
          {paragraph.full_text}
        </div>
      )}
    </div>
  );
};

export default ParagraphBox;
